import React from "react";
import { 
    ShoppingBag, 
    Smartphone, 
    Laptop, 
    Tv, 
    Shirt, 
    Sofa, 
    Headphones, 
    Watch,
    ShieldCheck, 
    Sparkles, 
    Clock3, 
    Wallet, 
    MapPin, 
    PackageCheck,
    CheckCircle2,
    TrendingUp,
    Users,
    Zap,
    Tag,
    Star
} from "lucide-react";

const AuthVisualHero = ({ activeStep = 1 }) => {
    return (
        <div className="nz-auth-visual-side">
            {/* Dynamic premium glowing graphic accents */}
            <div className="nz-auth-glow-accent-1"></div>
            <div className="nz-auth-glow-accent-2"></div>
            
            {/* 📦 Floating Mockup Cards (Premium E-commerce) */}
            <div className="nz-mockup-cluster-container">
                
                {/* 💻 Card 1: Electronics */}
                <div className="nz-mock-card nz-mock-card-electronics premium-card">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag-blue">
                            <Laptop size={10} className="nz-icon-inline-blue" />
                            Electronics
                        </span>
                        <span className="nz-mock-card-val-trending">
                            <Zap size={8} className="nz-icon-inline-orange" />
                            Trending
                        </span>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">📱</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">iPhone 15 Pro Max</div>
                            <div className="nz-mock-product-meta">Apple • ₹1,49,990</div>
                        </div>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">💻</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">MacBook Air M3</div>
                            <div className="nz-mock-product-meta">Apple • ₹1,14,900</div>
                        </div>
                    </div>

                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">🎧</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">AirPods Pro Gen 2</div>
                            <div className="nz-mock-product-meta">Audio • ₹24,900</div>
                        </div>
                    </div>
                </div>

                {/* 🏠 Card 2: Home Appliances */}
                <div className="nz-mock-card nz-mock-card-appliances premium-card">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag">
                            <Tv size={10} className="nz-icon-inline" />
                            Appliances
                        </span>
                        <span className="nz-mock-card-val-bestdeal">
                            <Star size={8} className="nz-icon-inline-yellow" />
                            Best Deals
                        </span>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">📺</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Samsung 55" OLED TV</div>
                            <div className="nz-mock-product-meta">Smart Home • 4K</div>
                        </div>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">❄️</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">LG Double Door Fridge</div>
                            <div className="nz-mock-product-meta">Inverter • 320L</div>
                        </div>
                    </div>
                </div>

                {/* ✨ Card 3: Fashion */}
                <div className="nz-mock-card nz-mock-card-fashion premium-card">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag-purple">
                            <Shirt size={10} className="nz-icon-inline-purple" />
                            Fashion
                        </span>
                        <span className="nz-mock-card-val-new">
                            <Sparkles size={8} className="nz-icon-inline-purple" />
                            New Arrivals
                        </span>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">👟</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Nike Air Max</div>
                            <div className="nz-mock-product-meta">Footwear • Men</div>
                        </div>
                    </div>
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">👜</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Gucci Handbag</div>
                            <div className="nz-mock-product-meta">Luxury • Women</div>
                        </div>
                    </div>
                </div>

                {/* 🪑 Card 4: Home & Furniture */}
                <div className="nz-mock-card nz-mock-card-furniture premium-card">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag-green">
                            <Sofa size={10} className="nz-icon-inline-green" />
                            Furniture
                        </span>
                        <span className="nz-mock-card-val-home">
                            <MapPin size={8} className="nz-icon-inline-green" />
                            Essentials
                        </span>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">🛋️</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Premium Sofa Set</div>
                            <div className="nz-mock-product-meta">Living Room</div>
                        </div>
                    </div>
                    <div className="nz-mock-product-row">
                        <span className="nz-emoji">🪑</span>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Ergonomic Chair</div>
                            <div className="nz-mock-product-meta">Office Desk</div>
                        </div>
                    </div>
                </div>

                {/* 📊 Card 5: Statistics */}
                <div className="nz-mock-card nz-mock-card-stats premium-card-orange">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag-white">
                            <TrendingUp size={10} className="nz-icon-inline-white" />
                            Marketplace
                        </span>
                    </div>
                    
                    <div className="nz-mock-stats-row">
                        <div className="nz-mock-stat-item">
                            <div className="nz-mock-stat-val">50K+</div>
                            <div className="nz-mock-stat-label">Products</div>
                        </div>
                        <div className="nz-mock-stat-divider"></div>
                        <div className="nz-mock-stat-item">
                            <div className="nz-mock-stat-val">1200+</div>
                            <div className="nz-mock-stat-label">Brands</div>
                        </div>
                    </div>
                    
                    <div className="nz-mock-savings-insight">
                        <Tag size={9} className="nz-icon-inline-orange" />
                        Up to 70% OFF Daily Deals
                    </div>

                    <div className="nz-mock-savings-footer">
                        <ShieldCheck size={8} className="nz-icon-inline-white-opacity-more" />
                        24/7 Customer Support
                    </div>
                </div>

            </div>

            {/* 📣 Premium Copy Slogan and Navigation Paginations */}
            <div className="nz-visual-slogan-section">
                <div className="nz-logo-badge mb-4">
                    <ShoppingBag size={12} className="nz-icon-inline-orange" />
                    <span>Premium Marketplace</span>
                </div>
                
                <h1 className="nz-visual-slogan-title">Everything You Need.<br />One Marketplace.</h1>
                
                <p className="nz-visual-slogan-desc">
                    Shop Electronics, Mobiles, Fashion, Furniture, Home Appliances, Beauty, Grocery, Sports, and thousands of products from trusted sellers across Nearzon.
                </p>
                
                <div className="nz-visual-paginator">
                    <div className={`nz-paginator-dot ${activeStep === 1 ? "active" : ""}`}></div>
                    <div className={`nz-paginator-dot ${activeStep === 2 ? "active" : ""}`}></div>
                    <div className={`nz-paginator-dot ${activeStep === 3 ? "active" : ""}`}></div>
                </div>
            </div>
        </div>
    );
};

export default AuthVisualHero;
